import React from 'react';
import './Car.css';

import { calculateAverageRating, useCompare  } from '../../utils';

import { FaStar, FaCar, FaUser, FaGasPump, FaCheck } from 'react-icons/fa';
import { FaCodeCompare } from "react-icons/fa6";

import { Link } from 'react-router-dom';



const Car = ({ car, list }) => {

  // Custom hook to manage car comparison functionality
  const { addToCompare, removeFromCompare, compare } = useCompare();

  // Calculate the average rating of the car based on user reviews
  const averageRating = calculateAverageRating(car); 

  // Generate the full car name using make and model details
  const carName = `${car.details.carMake} ${car.details.carModel}`;
  
  // Check if the car is already in the compare list
  const isCompared = compare.some(item => item.id === car.id);

  // Function to handle adding/removing car from the compare list
  const handleCompare = () => {
    if (isCompared) {
      removeFromCompare(car); // Remove from compare list
    } else {
      if (compare.length >= 3) {
        alert('You can only compare up to 3 cars at a time.');
      } else {
        addToCompare(car); // Add car to compare list
      }
    }
  };

  return ( 
    <div className="car-item">

      {/* Display car image */}
      <img src={car.image} alt={carName} />

      <div className="content">

        {/* Display car condition (New, Used, etc.) */}
        <div className="label">{car.condition}</div>

        {/* Car rating */}
        <div className='rating'>
          <div className='icon'>
            {/* Display star icons for rating */}
            <FaStar /> <FaStar /> <FaStar /> <FaStar /> <FaStar />
          </div>
          {/* Display average rating and number of comments */}
          {car.comments.length > 0 ? (
            <h5>{averageRating} ({car.comments.length})</h5>
          ) : (
            <h5>Not rated</h5>
          )}
        </div>

        {/* Car name with link to car details page */}
        <Link to={{
            pathname: '/Cars/' + carName,
          }}
          state={car}>
          <h2>{carName}</h2>
        </Link>

        {/* Car specifications */}
        <div className="details">
          <h3><FaCar className="icon" /><span>{car.details.year}</span></h3>
          <h3><FaUser className="icon" /><span>{car.details.passengers}</span></h3>
          <h3><FaGasPump className="icon" /><span>{car.details.fuelType}</span></h3>
        </div>

        {/* Display car description only in list view */}
        {list && <p>{car.content}</p>} {/* Product description */}
        
        <div className="bottom">

          {/* Car Price */}
          <div className="price">${car.price}</div>

          <div className="buttons">

            {/* Compare button to add/remove from comparison list */}
            <button
              className={`compare-btn button ${isCompared ? 'remove' : 'add'}`}
              onClick={handleCompare}
              data-tooltip={isCompared ? 'Remove from Compare' : 'Add to Compare'}  // Tooltip content for button
            >
              {isCompared ? <FaCheck /> : <FaCodeCompare />} {/* Icon changes based on state */}
            </button>

            {/* Link to car details page */}
            <Link
              to={{ pathname: '/Cars/' + carName }}
              state={car}
              className="button"
              data-tooltip="View Car Details"  // Tooltip content for link
            >
              <FaCar />
            </Link>

          </div>

        </div>
      </div>
    </div>
  );
};

export default Car;